import styled from 'styled-components';

import Button from '@components/Button/next';

export const GuestButton = styled(Button)`
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 19px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: ${({ theme }) => theme.palette.white};
  font-size: 14px;
  color: ${({ theme }) => theme.palette.matterHorn};
  margin-left: 5px;

  &:focus {
    background-color: ${({ theme }) => theme.palette.NL0};
    color: ${({ theme }) => theme.palette.coral};
    border-color: ${({ theme }) => theme.palette.coral};
  }
  &:active {
    box-shadow: none !important;
    color: ${({ theme }) => theme.palette.coral};
    border-color: ${({ theme }) => theme.palette.coral};
  }
`;

export const SavedGuestText = styled.span`
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SavedGuestsContainer = styled.div`
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  white-space: nowrap;
  height: 60px;
  max-width: 400px;
  @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    max-width: calc(100vw - 40px);
  }
`;

export const SaveGuestInfoButton = styled(Button)`
  height: 58px;
  display: flex;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  &:disabled {
    opacity: 0.5;
  }
  &&& {
    margin-left: 0;
  }
  box-shadow: 0 10px 30px 0 rgba(255, 65, 57, 0.5);
  opacity: 0.96;
  border-radius: 2px;
  font-size: 18px;
  @media (min-width: 769px) {
    height: 40px;
    min-width: 268px;
    font-size: 14px;
  }
`;
export const SaveGuestButton = styled(Button)`
  height: 40px;
  min-width: 181px;
  font-size: 14px !important;
  width: auto;
  display: flex;
  font-weight: 700;
  justify-content: center;
  align-items: center;
  border-color: ${({ theme }) => theme.palette.R600} !important;
  background-color: ${({ theme }) => theme.palette.R600} !important;
  color: ${({ theme }) => theme.palette.white} !important;

  &:disabled {
    opacity: 0.5;
    background-color: ${({ theme }) => theme.palette.white} !important;
    color: ${({ theme }) => theme.palette.black} !important;
  }
  &&& {
    margin-left: 0;
  }
  border-color: ${({ theme }) => theme.palette.black};
  background-color: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.black};
  opacity: 0.96;
  border-radius: 8px;
  font-size: 18px;
  :hover {
    border-color: ${({ theme }) => theme.palette.R600};
    background-color: ${({ theme }) => theme.palette.R600} !important;
    color: ${({ theme }) => theme.palette.white} !important;
    box-shadow: 0 10px 30px 0 ${({ theme }) => theme.palette.gray34};
  }
  @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    height: 40px;
    min-width: 100%;
  }
`;
